import { NgModule, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { NgMatModule } from '@shared/modules/ngmat.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FaceCheckModule } from 'src/app/_bio-check/face-check/face-check.module';
import { VoiceCheckModule } from 'src/app/_bio-check/voice-check/voice-check.module';
import { SharedModule } from '@shared/shared.module';
import { LayoutModule } from 'src/app/_layout/layout.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { OpenTracingInterceptor } from '@shared/interceptors/open-tracing.interceptor';
import { DebugModule } from 'src/app/debug/debug.module';
import { ConfigService } from '@shared/services/config';
import { AccountInterceptor } from '@shared/interceptors/account.interceptor';
import { DomModule } from '@shared/dom';
import { RetryHttpInterceptor } from '@shared/interceptors/retry-http.interceptor';
import { getWebauthnLibrary, WEBAUTHN_LIBRARY } from '@shared/services/webauthn/webauthn-library';
import { provideI18nService, I18nModule } from '@shared/i18n';
import { provideStore } from '@shared/store';
import { provideEnvironment } from './environment-provider';
import { ShortUrlRedirectComponent } from './short-url-redirect';
import { NomidioPageTitleModule } from '@shared/page-title';
import { ErrorReporterService, NomidioDevelopmentModule } from '@shared/development';
import { NomidioErrorPagesModule } from '@shared/error-pages';

const configInitializerFactory = (config: ConfigService) => {
  return async () => await config.load();
};

@NgModule({
  declarations: [AppComponent, ShortUrlRedirectComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    FaceCheckModule,
    VoiceCheckModule,
    AppRoutingModule,
    NgMatModule,
    SharedModule,
    LayoutModule,
    !environment.production ? DebugModule : [],
    DomModule,
    NomidioPageTitleModule,
    NomidioDevelopmentModule,
    NomidioErrorPagesModule,
    I18nModule
],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = configInitializerFactory(inject(ConfigService));
      return initializerFn();
    }),
    { provide: WEBAUTHN_LIBRARY, useFactory: getWebauthnLibrary, multi: false },
    { provide: HTTP_INTERCEPTORS, useClass: OpenTracingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AccountInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RetryHttpInterceptor, multi: true },
    { provide: ErrorHandler, useClass: environment.production ? ErrorHandler : ErrorReporterService },
    provideHttpClient(withInterceptorsFromDi()),
    provideI18nService(),
    provideStore(),
    provideEnvironment(),
    provideZoneChangeDetection(),
  ],
})
export class AppModule {}
